import { jsx as o } from "react/jsx-runtime";
import e from "./roche-horizontal-center.module.scss.js";
const l = ({ children: r, slot: t }) => r != null && (Array.isArray(r) ? r.length > 0 : !0) ? /* @__PURE__ */ o("div", { className: e["horizontal-center"], slot: t, children: r }) : null;
export {
  l as RocheUIHorizontalCenter
};
